import React from 'react'
import { withStyles, WithStyles, createStyles, Theme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import T from 'components/FormattedMessage'
import NavButton from 'components/NavButton'
import GameTypeCard from './GameTypeCard'
import classicGameIcon from './assets/classic_game_icon@2x.png'
import tournamentGameIcon from './assets/tournament_game_icon@2x.png'
import friendsGameIcon from './assets/friends_game_icon@2x.png'

interface Props {
  hasFriends: boolean
  createPublicGameUrl: string
  createPrivateGameUrl: string
  createClassicGameUrl?: string
}

const styles = ({ palette }: Theme) => createStyles({
  root: {
    padding: 0,
    listStyleType: 'none',
    color: palette.grey[900],
  },
  img: {
    maxWidth: '100%',
  },
  navButton: {
    padding: 0,
  },
  classicCard: {
    backgroundImage: 'linear-gradient(225deg, #F1F4F9 0%, #CDCFD3 100%)',
  },
  tournamentCard: {
    backgroundImage: 'linear-gradient(225deg, #07F7A9 0%, #00E89C 100%)',
  },
  friendsCard: {
    color: palette.common.white,
    backgroundImage: 'linear-gradient(225deg, #6FCFFF 0%, #3CA2FF 100%)',
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const GameTypeSelector: React.SFC<InjectedProps> = ({
  hasFriends,
  createPublicGameUrl,
  createPrivateGameUrl,
  createClassicGameUrl,
  classes,
}) => (
  <Grid
    container
    spacing={2}
    component="ul"
    direction="column"
    className={classes.root}
  >
    {createClassicGameUrl && (
      <Grid
        item
        component="li"
      >
        <NavButton
          block
          className={classes.navButton}
          to={createClassicGameUrl}
        >
          <GameTypeCard
            label={<T id="new_tag" />}
            icon={(
              <img
                alt=""
                src={classicGameIcon}
                className={classes.img}
              />
            )}
            title={<T id="gametype_title_classic" />}
            description={<T id="gametype_cta_classic" />}
            className={classes.classicCard}
          />
        </NavButton>
      </Grid>
    )}

    <Grid
      item
      component="li"
    >
      <NavButton
        block
        className={classes.navButton}
        to={createPublicGameUrl}
      >
        <GameTypeCard
          icon={(
            <img
              alt=""
              src={tournamentGameIcon}
              className={classes.img}
            />
          )}
          title={<T id="gametype_title_tournament" />}
          description={<T id="gametype_cta_tournament" />}
          className={classes.tournamentCard}
        />
      </NavButton>
    </Grid>
    <Grid
      item
      component="li"
    >
      <NavButton
        block
        className={classes.navButton}
        to={hasFriends ? createPrivateGameUrl : '/friends'}
      >
        <GameTypeCard
          icon={(
            <img
              alt=""
              src={friendsGameIcon}
              className={classes.img}
            />
          )}
          title={<T id="gametype_title_friends" />}
          description={<T id={hasFriends ? 'gametype_cta_friends' : 'gamesetup_type_invite'} />}
          className={classes.friendsCard}
        />
      </NavButton>
    </Grid>
  </Grid>
)

export default withStyles(styles)(GameTypeSelector)
